import { Component, Input, signal } from "@angular/core";
import { first } from "lodash";
import { LoggedUserViewModel } from "../../core";
import { UserService } from "../../services/user.service";

@Component({
  selector: "brd-user-image",
  templateUrl: "./user-image.component.html",
  styleUrls: ["./user-image.component.less"],
  standalone: false
})
export class UserImageComponent {
  @Input() mode: "readonly" | "edit" = "readonly";
  @Input() showStatus = true;

  displayName = signal("");

  constructor(userService: UserService) {
    userService.userInfo$.subscribe(user => {
      this.displayName.set(this.getShortDisplayName(user!));
    });
  }

  getShortDisplayName(user: LoggedUserViewModel): string {
    const displayName = !!user && !!user.fullName ? user.fullName : "--";

    const chunks = displayName.split(" ");
    const initials = chunks.length >= 2 ? chunks.map(segment => first(segment)).join("") : user?.fullName;

    if (initials == null) return "";

    return initials.substr(0, 2).toUpperCase();
  }
}
